module.exports = __webpack_public_path__ + "static/media/possible.60acc205.png";